import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxFlexiForward } from '@/store/flexi-forward/state.ts';

export const SavedFlexiForwardValidator = arkScope.type({
  'clientId?': 'number',
  properties: {
    'instrument?': "'AmericanForward'",
    'clientsWay?': "'Buy' | 'Sell'",
    'currencyPair?': 'string',
    'cutOffMarketPlace?': 'string',
    'deliveryDate?': 'string',
    'deltaHedgeAmount?': 'number | null',
    'deltaHedgeCurrencyIndex?': 'CurrencyChoice',
    'expiryDate?': 'string',
    'hedgeType?': "'Live' | 'Spot'",
    'marginCurrency?': 'string',
    'notional?': 'number | null',
    'notionalCurrencyIndex?': 'CurrencyChoice',
    'premiumDate?': 'string',
    'premiumType?': "'PPS' | 'AMOUNT' | 'PERCENT'",
    'premiumWay?': "'Bid' | 'Ask'",
    'rate?': 'number | null',
    'solvingType?': "'zeroCost' | 'solveRate' | 'solveUpfront'",
    'spotHedge?': 'string',
    'startDate?': 'string',
    'upfront?': 'number | null',
    'upfrontCurrency?': 'string',
  },
  tileId: 'string',
  type: "'FlexiForward'",
});
export type SavedFlexiForward = typeof SavedFlexiForwardValidator.infer;

export const SavedFlexiForward = {
  fromFlexiForward: (flexiForward: FxFlexiForward, tileId: string): SavedFlexiForward => {
    return {
      clientId: flexiForward.clientId,
      properties: {
        ...flexiForward.properties,
      },
      tileId,
      type: 'FlexiForward',
    };
  },
} as const;
